import { Link, createFileRoute } from '@tanstack/react-router';
import { useT } from '@/lib/i18n';
import { Construction } from 'lucide-react';
import { UNAVAILABLE, UNAVAILABLE_PREFIXES } from '@/app/navigation';
import { PageHeader } from '@/components/page-header';
import { Button } from '@/components/ui/button';

export const Route = createFileRoute('/$')({ component: NotBuilt });

/**
 * Catch-all: a screen that is planned but not built yet (UNAVAILABLE in app/navigation.ts)
 * says so plainly; anything else is a plain "page not found".
 */
function NotBuilt() {
  const { _splat } = Route.useParams();
  const t = useT();
  const path = `/${(_splat ?? '').replace(/\/+$/, '')}`;
  const title =
    UNAVAILABLE[path] ??
    (UNAVAILABLE_PREFIXES.some((p) => path.startsWith(p)) ? t('ui.comingSoon') : undefined);

  return (
    <>
      <PageHeader title={title ?? t('ui.pageNotFound')} />
      <div className="flex flex-col items-center justify-center rounded-lg border bg-card px-6 py-16 text-center">
        {title ? (
          <>
            <Construction className="mb-3 size-8 text-primary" aria-hidden />
            <p className="text-base font-medium" data-testid="not-available">
              {t('ui.notAvailable')}
            </p>
          </>
        ) : (
          <p className="text-base font-medium">{t('ui.noPage', { path })}</p>
        )}
        <Button asChild className="mt-6">
          <Link to="/dashboard">{t('ui.goToDashboard')}</Link>
        </Button>
      </div>
    </>
  );
}
